// Import polyfills first to ensure scheduler is available for React
import './polyfills'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app'

// Add dev utils to window object for easy console access in development
if (process.env.NODE_ENV === 'development') {
  Object.assign(window, {
    clearBusieCaches: () => {
      localStorage.removeItem('dev_auth_tokens')
      localStorage.removeItem('dev_api_responses')
      console.log('🧹 Development caches cleared!')
    },
  })
}

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element not found')
const root = createRoot(rootElement)

root.render(
  <StrictMode>
    <App />
  </StrictMode>
)
